import { render, staticRenderFns } from "./WatchVote.vue?vue&type=template&id=87d7f274"
import script from "./WatchVote.vue?vue&type=script&lang=js"
export * from "./WatchVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports